export enum PresentationTiming {
    None = 0,
    Firm = 1,
    Flexible = 2,
    Proportional = 3,
}

